<template>
  <div
    v-editable="blok"
    class="newsletter-content"
    :class="`newsletter-content--${size}`"
  >
    <h2 v-if="title">
      {{ title }}
    </h2>
    <p
      v-if="showDescription && description && description !== ' '"
      class="description"
    >
      {{ description }}
      <NuxtLink
        v-if="learnMoreLink"
        :to="
          learnMoreLink.linktype === 'url'
            ? learnMoreLink?.url
            : `/${learnMoreLink?.cached_url}`
        "
      >
        Learn more
        <i aria-hidden="true" class="icon">
          <Icon :size="12" name="fa6-solid:arrow-right" />
        </i>
      </NuxtLink>
    </p>
    <BenefitsList
      v-if="showBenefits"
      :benefits="benefits"
      :size="size"
      :class="[{ 'without-border': benefits?.length === 1 }, benefitsClass]"
    />
  </div>
</template>

<script lang="ts" setup>
import type {
  BlockSubscriptionSettingsStoryblok,
  NewsletterConfigStoryblok,
  NewsletterContentStoryblok,
} from '~/types/storyblok'

const props = withDefaults(
  defineProps<{
    blok?:
      | BlockSubscriptionSettingsStoryblok
      | NewsletterConfigStoryblok
      | NewsletterContentStoryblok
    size?: 'sm' | 'default'
    showDescription?: boolean
    showBenefits?: boolean
    benefitsClass?: string
    contentType?: string
  }>(),
  {
    blok: undefined,
    size: 'default',
    showDescription: true,
    showBenefits: true,
    benefitsClass: '',
    contentType: undefined,
  },
)

const { title, description, benefits, learnMoreLink } = useNewsletterContent(
  props.blok,
  props.contentType,
)
</script>

<style lang="less" scoped>
.newsletter-content {
  h2,
  .description {
    margin-bottom: 0 !important;
  }

  h2 + .description {
    margin-top: 0.75em;
  }

  a {
    font-size: 87.5%;
    margin: 0 @3px;
    white-space: nowrap;

    .icon {
      margin-left: @3px;
      line-height: 1;
    }

    &:link,
    &:visited {
      color: inherit !important;
      opacity: 0.8;
    }
    &:hover,
    &:active {
      color: @color-primary !important;
      text-decoration: underline;
      opacity: 1;
    }
  }

  &.newsletter-content--sm {
    h2 {
      .h3();
    }

    .description {
      .font-base();
      .font-sm();
    }

    h2 + .description {
      margin-top: 0.75em;
    }
  }
}
</style>
